var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewDriver = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0NewDriver)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20,
    r: 16,
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.273 14.663C24.2956 13.5604 25.2094 12.6665 26.3139 12.6665C27.4185 12.6665 28.2956 13.5604 28.273 14.663C28.2505 15.7657 27.3367 16.6595 26.2322 16.6595C25.1276 16.6595 24.2505 15.7657 24.273 14.663ZM22.8034 21.3181H29.4701C29.7012 21.3174 29.9179 21.1973 30.0428 21.0007C30.1677 20.8041 30.183 20.5591 30.0832 20.3531L29.4758 19.0887C29.1496 18.4151 28.4671 17.9903 27.7116 17.9906H24.6982C23.9427 17.9903 23.2429 18.4151 22.8891 19.0887L22.2299 20.3531C22.1217 20.5591 22.1269 20.8041 22.2438 21.0007C22.3606 21.1973 22.5724 21.3174 22.8034 21.3181ZM27.8495 22.6491H30.4429C30.5383 22.6399 30.6326 22.6704 30.7033 22.7334C30.774 22.7964 30.8148 22.8864 30.8161 22.9819L30.763 25.5707C30.7653 25.7071 30.6821 25.8322 30.5546 25.8842C30.4271 25.9361 30.2822 25.904 30.1916 25.8036L29.5386 25.1381C28.3448 26.4205 26.5499 26.95 24.8792 26.5126C23.2084 26.0753 21.938 24.7433 21.5812 23.0551C21.5647 22.9567 21.591 22.8551 21.6536 22.7756C21.7175 22.6953 21.8146 22.6486 21.9162 22.6491H22.5829C22.724 22.6453 22.8504 22.7306 22.8985 22.8621C23.2019 24.0306 24.1221 24.9285 25.2998 25.2055C26.4774 25.4825 27.7259 25.0945 28.5579 24.1931L27.6046 23.2148C27.5132 23.1197 27.4885 22.9783 27.5418 22.8551C27.5951 22.732 27.7161 22.651 27.8495 22.6491Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0NewDriver",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.294118 0 0 0 0 0.352941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewDriver, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewDriver.9e801547.svg";
export { ForwardRef as ReactComponent };